/** Product address syntax only. No transport, attachment, Node or browser dependencies. */
export class WhatsAppAddress {
    /** DOCUMENTED EXCEPTION: pure predicate; malformed or non-string input simply is not an address.
     * ERROR-SUPPRESSED-JUSTIFIED: no I/O or application error policy belongs in syntax classification. */
    public static IsJid = (Value: string): boolean => {
        if (typeof Value !== "string") { return false; }
        return /^[0-9]+(-[0-9]+)?@(s\.whatsapp\.net|g\.us|lid)$/.test(Value);
    };

    /** DOCUMENTED EXCEPTION: pure group suffix classification; send/settings permissions stay with each caller.
     * ERROR-SUPPRESSED-JUSTIFIED: non-string input simply is not a group address. */
    public static IsGroup = (Value: string): boolean => {
        if (typeof Value !== "string") { return false; }
        return /@g\.us$/.test(Value);
    };
}
